<template>
  <div>
    <el-switch
      v-model="createBaseFlag"
      class="base-switch"
      :active-text="$t('dBase.createBase')"
      :inactive-text="$t('dBase.bindExistingBase')"
      v-if="type === 'add' && !fromReference"
    ></el-switch>
    <el-form
      v-if="!createBaseFlag && !fromReference"
      :model="existBase"
      ref="exist"
      :rules="existRules"
    >
      <el-form-item :label="$t('dBase.server')" prop="serverId">
        <el-select
          v-model="existBase.serverId"
          :placeholder="$t('dBase.serverNotSelected')"
          filterable
          @change="existServerChanged"
        >
          <el-option
            v-for="(server, index) in getServersArray"
            :key="index"
            :value="server.id"
            :label="server.name"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('dBase.base')" prop="baseId">
        <el-select
          v-model="existBase.baseId"
          filterable
          :placeholder="$t('dBase.baseNotSelected')"
        >
          <el-option
            v-for="(base, index) in getExistBases"
            :key="index"
            :value="base.id"
            :label="base.name"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <el-form
      v-if="createBaseFlag || fromReference"
      :model="formData"
      :rules="rules"
      ref="form"
      class="main-form-scroll"
    >
      <el-form-item :label="$t('dBase.base')" prop="nameSelected">
        <el-input
          v-model="formData.nameSelected"
          :disabled="!!existBase.baseId"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('dBase.shortName')" prop="shortNameSelected">
        <el-input
          v-model="formData.shortNameSelected"
          :disabled="!!existBase.baseId"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('dBase.alias')" prop="aliasSelected">
        <el-input
          v-model="formData.aliasSelected"
          :disabled="!!existBase.baseId"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('dBase.comment')" prop="commentSelected">
        <el-input
          v-model="formData.commentSelected"
          :disabled="!!existBase.baseId"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('dBase.baseType')" prop="baseSelected">
        <el-select
          v-model="formData.baseSelected"
          :placeholder="$t('dBase.baseTypeNotSelected')"
          filterable
          :disabled="!!existBase.baseId"
        >
          <el-option
            v-for="base in getTypeDb"
            :key="base.typeDbID"
            :value="base.typeDbID"
            :label="base.typeDbName"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('dBase.server')" prop="serverSelected">
        <el-select
          v-model="formData.serverSelected"
          v-if="!serverParent"
          filterable
          :placeholder="$t('dBase.serverNotSelected')"
        >
          <el-option
            v-for="(server, index) in getServersArray"
            :key="index"
            :value="server.id"
            :label="server.name"
          ></el-option>
        </el-select>
        <b v-else>{{ serverParent }}</b>
      </el-form-item>
    </el-form>
    <div slot="footer" class="bottom-buttons">
      <div></div>
      <div>
        <el-button class="button-cancel" type="plain" @click="cancelClick">{{
          $t("dBase.cancel")
        }}</el-button>
        <el-button class="button-confirm" type="success" @click="okClick"
          >OK</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    type: String,
    fromReference: Boolean,
  },
  data() {
    const validateShortName = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t("dBase.enterBaseShortName")));
      } else if (value.trim().includes(" ")) {
        callback(new Error(this.$t("errors.nameHasSpace")));
      } else {
        callback();
      }
    };
    const validateBaseName = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t("dBase.enterBaseName")));
      } else if (value.trim().includes(" ")) {
        callback(new Error(this.$t("errors.nameHasSpace")));
      } else {
        callback();
      }
    };
    return {
      createBaseFlag: false,
      existBase: {
        baseId: null,
        serverId: null,
      },
      existRules: {
        baseId: [
          {
            required: true,
            message: this.$t("dBase.enterBaseName"),
            trigger: "blur",
          },
        ],
        serverId: [
          {
            required: true,
            message: this.$t("dBase.enterServer"),
            trigger: "change",
          },
        ],
      },
      formData: {
        nameSelected: null,
        shortNameSelected: null,
        aliasSelected: null,
        commentSelected: null,
        baseSelected: null,
        serverSelected: null,
      },
      rules: {
        nameSelected: [
          {
            required: true,
            validator: validateBaseName,
            trigger: "blur",
          },
        ],
        shortNameSelected: [
          {
            required: true,
            validator: validateShortName,
            trigger: "blur",
          },
        ],
        aliasSelected: [{ required: false }],
        commentSelected: [{ required: false }],
        baseSelected: [
          {
            required: true,
            message: this.$t("dBase.enterBaseType"),
            trigger: "change",
          },
        ],
        serverSelected: [
          {
            required: true,
            message: this.$t("dBase.enterBaseServer"),
            trigger: "change",
          },
        ],
      },
      serverParent: null,
    };
  },
  created() {
    if (this.type === "add") {
      if (this.getParentServerId && !this.fromReference) {
        this.$store
          .dispatch("getExistBasesPS", this.getParentServerId)
          .then(() => {
            this.existBase.serverId = this.getParentServerId;
            this.formData.serverSelected = this.getParentServerId;
            this.serverParent = this.getServersArray.find(
              (element) => element.id === this.getParentServerId
            ).name;
          });
      } else if (this.fromReference) {
        this.serverParent = null;
      } else this.$store.commit("setError", "No server selected");
    } else if (this.type === "edit") {
      this.populateForm();
    }
  },
  methods: {
    existServerChanged() {
      //console.log("in form: ", this.existBase);
      this.$store.commit("setLoading", true);
      this.$store
        .dispatch("getExistBasesPS", this.existBase.serverId)
        .then(() => {
          this.$store.commit("setLoading", false);
          // this.existBaseChange();
        })
        .catch(() => {
          this.$store.commit("setLoading", false);
        });
    },
    populateForm() {
      this.formData.nameSelected = this.getCurInfo.name;
      this.formData.shortNameSelected = this.getCurInfo.shortName;
      this.formData.aliasSelected = this.getCurInfo.alias;
      this.formData.commentSelected = this.getCurInfo.comment;
      this.formData.baseSelected = this.getCurInfo.idTypeDb;
      this.formData.serverSelected = this.getCurInfo.idServer;
    },
    okClick() {
      if (this.createBaseFlag || this.fromReference) {
        for (let index in this.formData) {
          if (
            this.formData[index] != null &&
            typeof this.formData[index] === "string"
          ) {
            this.formData[index] = this.formData[index].trim();
          }
        }
        this.$refs["form"].validate((valid, object) => {
          if (valid) {
            this.$emit("data", this.formData);
          } else {
            this.$message.error(this.$t("errors.notAllRequiredFieldsSelected"));
          }
        });
      } else if (!this.createBaseFlag && !this.fromReference) {
        // if (!!this.existBase.inputBaseName) {
        //   this.existBase.inputBaseName = this.existBase.inputBaseName.trim();
        //   let base = this.getExistBases.find(
        //     (b) => b.name === this.existBase.inputBaseName
        //   );
        //   if (!base) {
        //     this.$message.error("Такой базы не существует");
        //     return;
        //   }
        //   this.existBase.baseId = base.id;
        // }
        this.$refs["exist"].validate((valid, object) => {
          if (valid) {
            this.$emit("data", this.existBase);
          } else {
            this.$message.error(this.$t("errors.notAllRequiredFieldsSelected"));
          }
        });
      } else {
        this.$message.error(this.$t("dBase.createError"));
      }
    },
    cancelClick() {
      this.$emit("close");
    },
  },
  computed: {
    ...mapGetters([
      "getServersArray",
      "getTypeDb",
      "getExistBases",
      "getParentServerId",
      "getCurInfo",
    ]),
  },
};
</script>

<style scoped>
.base-switch {
  margin-bottom: 10px;
}
</style>